import React from 'react';
import "../sample/global.scss";
import DynamicTable from '../tables/DynamicTable';

    interface MijlpalenBoxProps {
        title: string;
        project: any;
    }
    
    const MijlpalenBox = ({ title, project }: MijlpalenBoxProps) => {
        return (
            <div className='box'>
                <h2>{title}</h2>
                <DynamicTable
                    data={project?.declarations?.models.filter((milestone: any) => milestone.teams === true)}
                    columns={[
                        { id: 1, label: 'Datum', property: 'date' },
                        { id: 2, label: 'Type', property: 'type.name' },
                        { id: 3, label: 'Subtype', property: 'subType.name' },
                        { id: 4, label: 'Beschrijving', property: 'description' },
                    ]}
                />
            </div>
        );
    };

export default MijlpalenBox;
